import { useEffect } from "react";
import "./ClickEffect.css";

export default function ClickEffect() {
  useEffect(() => {
    const colors = [
      "#FF8A00",
      "#FFA726",
      "#FFD54F",
      "#FFFFFF",
    ];

    const createParticle = (x, y) => {
      const particle = document.createElement("span");
      particle.className = "particle";

      const angle = Math.random() * Math.PI * 2;
      const distance = 50 + Math.random() * 80;

      particle.style.setProperty("--dx", `${Math.cos(angle) * distance}px`);
      particle.style.setProperty("--dy", `${Math.sin(angle) * distance}px`);

      particle.style.left = `${x}px`;
      particle.style.top = `${y}px`;

      particle.style.background =
        colors[Math.floor(Math.random() * colors.length)];

      particle.style.width = `${6 + Math.random() * 6}px`;
      particle.style.height = particle.style.width;

      document.body.appendChild(particle);

      setTimeout(() => particle.remove(), 900);
    };

    const createRing = (x, y) => {
      const ring = document.createElement("span");
      ring.className = "click-ring";

      ring.style.left = `${x}px`;
      ring.style.top = `${y}px`;

      document.body.appendChild(ring);

      setTimeout(() => ring.remove(), 700);
    };

    const handleClick = (e) => {
      createRing(e.clientX, e.clientY);

      for (let i = 0; i < 18; i++) {
        createParticle(e.clientX, e.clientY);
      }
    };

    window.addEventListener("pointerdown", handleClick);

    return () =>
      window.removeEventListener("pointerdown", handleClick);
  }, []);

  return null;
}